export function parseAdaptiveCouponId(key: string): {
  discountPercent: number;
  discountMonths: number;
} {
  const cleanedKey = key.replace('churnkey-ai-', '').replace('-percent', '');
  const [percent, months] = cleanedKey.split('-').map(Number);
  return { discountPercent: percent, discountMonths: months };
}